export default class Eventify {
    constructor() {
        this.list = {}
    }

    trigger(event, eventObject = {}) {
        eventObject._name = event
        if (!this.list[event]) return
        for (const handlerObject of this.list[event]) {
            handlerObject.handler(eventObject)
            handlerObject.once && this.off(event, handlerObject.handler)
        }
    }

    on(event, handler, once = false) {
        if (!this.list[event]) this.list[event] = []
        this.list[event].push({ once: once, handler: handler })
    }

    once(event, handler) {
        this.on(event, handler, true)
    }

    off(event, handler) {
        if (!event) this.list = {}
        if (!this.list[event]) return
        if (!handler) this.list[event] = []
        const indexToRemove = this.list[event].findIndex(
            (eventObject) => eventObject.handler === handler
        )
        indexToRemove > -1 && this.list[event].splice(indexToRemove, 1)
    }
}

